{
  "name": "medisend-frontend",
  "version": "17.0.14",
  "packageManager": "pnpm@10.34.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test:ci": "BROWSERSLIST='last 2 Chrome major versions' ng test --no-watch --coverage --coverage-exclude 'src/testing/**' && npm run report:coverage && npm run report:sonar-metrics",
    "report:sonar-metrics": "node node_modules/@halodoc/test-utils/coverage/build-sonar-metrics.mjs --src src",
    "report:coverage": "node node_modules/@halodoc/test-utils/coverage/report-coverage.mjs --src src",
    "report:branch-arms": "node node_modules/@halodoc/test-utils/coverage/branch-arm-report.mjs coverage/lcov.info src",
    "report:interactions": "node node_modules/@halodoc/test-utils/coverage/template-interaction-report.mjs",
    "doctor": "node node_modules/@halodoc/test-utils/coverage/check-wiring.mjs",
    "prod-build": "ng build medisend-frontend -c production && pnpm run concat-sw",
    "prerender-stage": "pnpm run stage-build",
    "prerender-preprod": "ng build medisend-frontend -c preprod && pnpm run concat-sw",
    "prerender-production": "pnpm run prod-build",
    "stage-build": "ng build medisend-frontend -c stage && pnpm run concat-sw-stage",
    "concat-sw": "concat dist/browser/sw_webpush.js dist/browser/ngsw-worker.js dist/browser/firebase-messaging-sw.js -o dist/browser/combined-worker.js",
    "concat-sw-stage": "concat dist/browser/sw_webpush.js dist/browser/ngsw-worker.js dist/browser/stage-firebase-messaging-sw.js -o dist/browser/combined-worker.js",
    "test": "BROWSERSLIST='last 2 Chrome major versions' ng test --coverage",
    "lint": "node scripts/check-i18n-collisions.mjs && eslint src",
    "lint-report": "node scripts/check-i18n-collisions.mjs && eslint src -f node_modules/@halodoc/eslint-config/src/lib/sonarqube-formatter.js -o eslint-report.json",
    "lint-fix": "eslint src --fix",
    "e2e": "ng e2e",
    "run:all": "node node_modules/@halodoc/module-federation/src/server/mf-dev-server.js",
    "prettier": "prettier --write .",
    "prepare": "husky",
    "bundle-analyzer": "ng build medisend-frontend -c production --source-map && pnpm run concat-sw && source-map-explorer dist/browser/**/*.js",
    "preinstall": "npx only-allow pnpm",
    "serve-ssr": "ng run medisend-frontend:serve-ssr",
    "serve:ssr:fed": "node --import @angular-architects/native-federation-v4/node-preload dist/server/server.mjs",
    "analyze:prod": "ng build medisend-frontend -c analyze && pnpm run analyze:report",
    "analyze:report": "node scripts/analyze-bundle.mjs --stats dist/stats.json --dist dist",
    "analyze:compare": "node scripts/compare-bundle.mjs --baseline bundle-baseline.json --current bundle-report.json --md bundle-delta.md",
    "analyze:deps": "node scripts/analyze-deps.mjs --report bundle-report.json --md bundle-deps.md",
    "analyze:gate": "pnpm run analyze:prod && node scripts/compare-bundle.mjs --baseline bundle-baseline.json --current bundle-report.json --md bundle-delta.md --min-reduction -0.5 --metric eager-gzip"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.15",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.17",
    "@angular/compiler": "21.2.17",
    "@angular/core": "21.2.17",
    "@angular/forms": "21.2.17",
    "@angular/material": "21.2.14",
    "@angular/platform-browser": "21.2.17",
    "@angular/platform-browser-dynamic": "21.2.17",
    "@angular/platform-server": "21.2.17",
    "@angular/router": "21.2.17",
    "@angular/service-worker": "21.2.17",
    "@angular/ssr": "^21.2.18",
    "@halodoc/erx": "13.3.0",
    "@halodoc/eslint-config": "9.0.0",
    "@halodoc/pdf-thumbnail": "13.3.0",
    "@halodoc/user-media": "5.4.0",
    "@halodoc/utils": "3.3.0",
    "@hd-base/assets": "8.3.0",
    "@hd-base/atoms": "13.4.0",
    "@hd-base/design-tokens": "7.3.0",
    "@hd-base/molecules": "15.4.0",
    "@hd-base/organisms": "14.3.0",
    "@medisend/auth": "10.2.0",
    "@medisend/core": "9.3.0",
    "@medisend/portal-apotek-shell": "9.3.0",
    "@medisend/shared": "9.2.0",
    "@medisend/webview-bridge": "9.2.0",
    "@ngx-translate/core": "catalog:",
    "@ngx-translate/http-loader": "17.0.0",
    "axios": "^1.4.0",
    "canvas": "file:src/stubs/canvas",
    "dotenv": "^16.0.3",
    "es-module-shims": "^2.8.0",
    "express": "^4.15.2",
    "fingerprintjs2": "2.1.0",
    "firebase": "10.9.0",
    "helmet": "^6.0.1",
    "luxon": "1.28.1",
    "morgan": "^1.10.0",
    "ng2-pdf-viewer": "catalog:",
    "ngx-device-detector": "catalog:ng21",
    "ngx-extended-pdf-viewer": "catalog:",
    "ngx-infinite-scroll": "catalog:ng21",
    "ngx-mask": "catalog:ng21",
    "ngx-material-timepicker": "^5.5.3",
    "ngx-panzoom": "17.0.0",
    "ngx-ui-tour-md-menu": "16.0.0",
    "pdfjs-dist": "catalog:",
    "rotating-file-stream": "^3.1.0",
    "rxfire": "^6.0.3",
    "rxjs": "^7.8.1",
    "tslib": "^2.6.2",
    "uuid": "^9.0.0",
    "xhr2": "^0.2.1",
    "xss": "catalog:",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-architects/native-federation-v4": "~21.2.1",
    "@angular-devkit/build-angular": "21.2.18",
    "@angular/build": "21.2.18",
    "@angular/cli": "21.2.18",
    "@angular/compiler-cli": "21.2.17",
    "@babel/core": "^8.0.1",
    "@halodoc/tailwind-config": "5.3.0",
    "@halodoc/test-utils": "1.21.0",
    "@softarc/native-federation-orchestrator": "^4.0.0",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/user-event": "^14.6.6",
    "@types/express": "^4.17.0",
    "@types/fingerprintjs2": "^2.0.0",
    "@types/luxon": "^1.25.0",
    "@types/node": "^22.20.1",
    "@types/pdfjs-dist": "2.1.7",
    "@types/uuid": "^8.3.4",
    "@typescript-eslint/eslint-plugin": "catalog:",
    "@typescript-eslint/parser": "catalog:",
    "@vitest/coverage-v8": "^4.1.10",
    "angular-eslint": "catalog:ng21",
    "autoprefixer": "^10.4.14",
    "browser-sync": "^3.0.4",
    "codelyzer": "^6.0.0",
    "concat": "^1.0.3",
    "eslint": "catalog:",
    "eslint-plugin-unused-imports": "catalog:",
    "husky": "catalog:",
    "jsdom": "^27.0.1",
    "lint-staged": "^13.0.3",
    "ng-packagr": "^21.2.5",
    "postcss": "^8.4.21",
    "prettier": "^3.3.3",
    "protractor": "~7.0.0",
    "source-map-explorer": "^2.5.3",
    "tailwindcss": "^3.3.1",
    "ts-node": "~8.3.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "catalog:",
    "vitest": "^4.1.10",
    "yargs": "^17.7.2",
    "eslint-plugin-diff": "^2.1.7"
  },
  "lint-staged": {
    "src/**/*.{html,ts,scss}": [
      "prettier --write"
    ],
    "src/**/*.ts": [
      "eslint --fix"
    ]
  },
  "engines": {
    "pnpm": ">=10.4.0"
  }
}
